const ANALYZE_CHECKOUT_STEP_VIEW = 'ANALYZE_CHECKOUT_STEP_VIEW';
const ANALYZE_ORDER_CONFIRMATION_PAGE = 'ANALYZE_CONFIRMATION_PAGE_VIEW';

export {
  ANALYZE_CHECKOUT_STEP_VIEW,
  ANALYZE_ORDER_CONFIRMATION_PAGE,
};
